import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";

function Dashboard() {
  const { loading: profileLoading } = useSelector((state) => state.profile);
  const { loading: authLoading } = useSelector((state) => state.auth);
  const [isCollapsed, setCollapsed] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  if (profileLoading || authLoading) {
    return (
      <div className="grid min-h-[calc(100vh-6rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    );
  }

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div className="flex h-screen font-sans bg-white dark:bg-[#00254D] text-black dark:text-white transition-colors duration-300">
      <Sidebar isCollapsed={isCollapsed} darkMode={darkMode} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Navbar
          isCollapsed={isCollapsed}
          setCollapsed={setCollapsed}
          darkMode={darkMode}
          toggleTheme={toggleTheme}
        />
        <main className="flex-1 overflow-y-auto  bg-gray-50 dark:bg-[#00254D] transition-colors duration-300">
          <Outlet context={{ darkMode }} />
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
